import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/landing/Navbar";
import { VideoHero } from "@/components/landing/VideoHero";
import { TrustBar } from "@/components/landing/TrustBar";
import { BusinessPathsSection } from "@/components/landing/BusinessPathsSection";
import { useLandingMetadata } from "@/lib/useLandingMetadata";
import { ProblemSection } from "@/components/landing/ProblemSection";
import { TransformationSection } from "@/components/landing/TransformationSection";
import { SpecialistSection } from "@/components/landing/SpecialistSection";
import { SecuritySection } from "@/components/landing/SecuritySection";
import { ProcessSection } from "@/components/landing/ProcessSection";
import { UseCasesSection } from "@/components/landing/UseCasesSection";
import { VisualProofSection } from "@/components/landing/VisualProofSection";
import { TransformationSequence } from "@/components/landing/TransformationSequence";
import { TestimonialsSection } from "@/components/landing/TestimonialsSection";
import { BusFactorSection } from "@/components/landing/BusFactorSection";
import { ComparisonSection } from "@/components/landing/ComparisonSection";
import { ServiceMaintenanceSection } from "@/components/landing/ServiceMaintenanceSection";
import { LeadMagnetSection } from "@/components/landing/LeadMagnetSection";
import { FAQSection } from "@/components/landing/FAQSection";
import { AboutSection } from "@/components/landing/AboutSection";
import { FinalCTA } from "@/components/landing/FinalCTA";
import { ContactSection } from "@/components/landing/ContactSection";
import { Footer } from "@/components/landing/Footer";
import { StickyMobileCTA } from "@/components/landing/StickyMobileCTA";
import { AdminPage } from "@/components/admin/AdminPage";
import { PrivacyPage } from "@/components/landing/PrivacyPage";
import { SecureSystemAuditPage } from "@/components/audit/SecureSystemAuditPage";
import { BookingPage } from "@/components/booking/BookingPage";
import { CookieConsent } from "@/components/landing/CookieConsent";
import VideoTestPage from "@/components/landing/VideoTestPage";

function Landing() {
  useLandingMetadata();
  useEffect(() => {
    // Remove the platform attribution badge from the public landing page.
    const remove = () => document.getElementById("emergent-badge")?.remove();
    remove();
    const t = setTimeout(remove, 1500);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="App relative">
      <div className="noise" />
      <Navbar />
      <main>
        <VideoHero />
        <TrustBar />
        <BusinessPathsSection />
        <ProblemSection />
        <TransformationSequence />
        <SpecialistSection />
        <UseCasesSection />
        <TransformationSection />
        <VisualProofSection />
        <SecuritySection />
        <ProcessSection />
        <TestimonialsSection />
        <BusFactorSection />
        <ComparisonSection />
        <ServiceMaintenanceSection />
        <AboutSection />
        <FAQSection />
        <LeadMagnetSection />
        <FinalCTA />
        <ContactSection />
      </main>
      <Footer />
      <StickyMobileCTA />
      <Toaster position="top-center" theme="dark" richColors closeButton />
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/privacy" element={<PrivacyPage />} />
        <Route path="/secure-system-audit" element={<SecureSystemAuditPage />} />
        <Route path="/book" element={<BookingPage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/video-test" element={<VideoTestPage />} />
      </Routes>
      <CookieConsent />
    </BrowserRouter>
  );
}

export default App;
